import type { ReactNode } from 'react';

/** Symbole der Formatierungsleiste (24er Raster, Strichstärke wie die übrigen Icons). */
export type EditorIconKind = 'undo' | 'redo' | 'bold' | 'italic' | 'strike' | 'bullets' | 'numbered' | 'quote' | 'link' | 'sun' | 'moon' | 'pin' | 'clock';

const ICONS: Record<EditorIconKind, ReactNode> = {
  undo: (
    <>
      <path d="M9 14L4 9l5-5" />
      <path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" />
    </>
  ),
  redo: (
    <>
      <path d="M15 14l5-5-5-5" />
      <path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13" />
    </>
  ),
  bold: (
    <>
      <path d="M7 5h6.5a3.5 3.5 0 0 1 0 7H7z" />
      <path d="M7 12h7.5a3.5 3.5 0 0 1 0 7H7z" />
    </>
  ),
  italic: (
    <>
      <path d="M19 4h-9" />
      <path d="M14 20H5" />
      <path d="M15 4L9 20" />
    </>
  ),
  strike: (
    <>
      <path d="M16.5 7.5C16 5.5 14.2 4 12 4 9.5 4 7.5 5.6 7.5 7.8c0 1.3.7 2.3 2 3" />
      <path d="M4 12h16" />
      <path d="M7.5 16.5c.5 2 2.3 3.5 4.7 3.5 2.6 0 4.6-1.5 4.6-3.7 0-.8-.2-1.5-.7-2.1" />
    </>
  ),
  bullets: (
    <>
      <path d="M9 6h11M9 12h11M9 18h11" />
      <circle cx="4.5" cy="6" r="1.2" fill="currentColor" />
      <circle cx="4.5" cy="12" r="1.2" fill="currentColor" />
      <circle cx="4.5" cy="18" r="1.2" fill="currentColor" />
    </>
  ),
  numbered: (
    <>
      <path d="M10 6h10M10 12h10M10 18h10" />
      <path d="M4 4.5l1.5-1v5" strokeWidth="1.5" />
      <path d="M3.5 11.2c.3-.6.9-.9 1.5-.9.8 0 1.4.5 1.4 1.2 0 1.1-2.9 2.3-2.9 3h3" strokeWidth="1.5" />
    </>
  ),
  quote: (
    <>
      <path d="M4 5v14" strokeWidth="3" />
      <path d="M9 7h11M9 12h11M9 17h7" />
    </>
  ),
  link: (
    <>
      <path d="M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1.2 1.2" />
      <path d="M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1.2-1.2" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
    </>
  ),
  moon: <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  pin: (
    <>
      <path d="M12 17v5" />
      <path d="M9 10.8a2 2 0 0 1-1.1 1.8l-1.8.9A2 2 0 0 0 5 15.2V17h14v-1.8a2 2 0 0 0-1.1-1.8l-1.8-.9a2 2 0 0 1-1.1-1.8V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1z" />
    </>
  ),
};

export function EditorIcon({ kind, size = 18 }: { kind: EditorIconKind; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={kind === 'bold' ? 2.4 : 2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {ICONS[kind]}
    </svg>
  );
}
